import React from "react";
import LicenseState from "license/LicenseState";
const StateCell = ({ violations, version = void 0 }) => /* @__PURE__ */ React.createElement(LicenseState, { violations, version });
export default StateCell;
